import React, { useState, useEffect, useRef } from 'react';
import GridCenterItem from '../GridCenterItem';
import CustomPhoneInput from '../customPhoneInput';
import TextFieldComp from '../TextFieldComp';
import CustomButton from '../viewEventUi/CustomButton';
import { resendTimerOTP } from '../../constants';
import Typography from '@material-ui/core/Typography';

function AskMobNum({
  form,
  handleEnter,
  // onChangeUser,
  otpClass,
  inputStyles,
  sendOTPFunc,
  phoneErrorCls,
  signinBtn,
  login_fun,
}) {
  const otpTimerRef = useRef();
  const [otpTime, setOtpTime] = useState(0);
  const [startTimer, setStartTimer] = useState(false);
  const [phone, setPhone] = useState({
    phoneNum: { num: '', country: '' },
    otpNum: '',
  });

  const [errors, setErrors] = useState({});
  const sendOtpTxt = 'send otp';
  const waitOtpText = `re-send otp (${otpTime} s)`;

  const onChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setPhone((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  const onChangePhone = (value, country) => {
    // console.log(
    //   value,
    //   country,
    //   'values',
    //   country.format,
    //   typeof country.format,
    //   // country.format.replaceAll(' ', '').replaceAll('+', '').replaceAll('-', '').replaceAll('(','').replaceAll(')','')
    // );
    onChange({
      target: {
        value: { num: value, country: country.name },
        name: 'phoneNum',
      },
    });
  };

  const clearRetryTimeInterval = () => {
    clearInterval(otpTimerRef?.current);
  };

  const timerFunc = (count) => {
    if (count > 0) {
      return count - 1;
    } else {
      clearRetryTimeInterval();
      setStartTimer(false);
      return 0;
    }
  };

  const activateInterval = () => {
    setOtpTime((prevTime) => timerFunc(prevTime));
  };

  const initiateTimer = () => {
    otpTimerRef.current = setInterval(activateInterval, 1000);
  };

  const phoneNumberValidationFunc = () => {
    // console.log(typeof phone.phoneNum);
    if (phone.phoneNum.num.length <= 5) {
      return false;
    } else {
      return true;
    }
  };

  const onClickSendOTP = (e) => {
    e.preventDefault();
    const errors = {};
    const isPhoneNumValid = phoneNumberValidationFunc();
    if (!isPhoneNumValid) {
      errors.phoneNum = 'Phone number invalid';
      // return null;
    }
    if (!otpTime && isPhoneNumValid) {
      setOtpTime(resendTimerOTP);
      setStartTimer(true);
      // initiateTimer();
      sendOTPFunc(phone.phoneNum.num);
    }
    setErrors({ ...errors });
    return null;
  };

  const handleTimer = () => {
    if (startTimer) {
      initiateTimer();
    } else {
      clearRetryTimeInterval();
    }
  };

  useEffect(() => {
    handleTimer();
    return () => {
      clearRetryTimeInterval();
    };
  }, [startTimer]);

  return (
    <form className={form} noValidate>
      <GridCenterItem noControl={true}>
        <CustomPhoneInput
          // disabled={disabled ? true : false}
          label="Phone Number *"
          placeholder="Phone Number"
          error={!!errors?.phoneNum}
          helpertext={errors?.phoneNum}
          value={phone.phoneNum.num}
          onChange={onChangePhone}
          handleEnter={handleEnter}
          // phoneErrorCls={phoneErrorCls}
        />
      </GridCenterItem>

      <GridCenterItem noControl={true}>
        <TextFieldComp
          // disabled={fromProfPage ? true : false}
          name="otpNum"
          label="OTP *"
          placeholder="Enter OTP"
          error={!!errors?.otpNum}
          helpertext={errors?.otpNum}
          value={phone.otpNum}
          onChange={onChange}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
          // blurHandle={mailBlurHandle ? mailBlurHandle : () => null}
        />
      </GridCenterItem>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <CustomButton
          btnStyle={signinBtn}
          clickHandle={login_fun}
          btnText={'JOIN NOW'}
        />
        <Typography
          component="button"
          gutterBottom
          variant="button"
          // onClick={sendOTPFunc}
          onClick={onClickSendOTP}
          className={otpClass}
        >
          {!otpTime ? sendOtpTxt : waitOtpText}
        </Typography>
      </div>
    </form>
  );
}

export default AskMobNum;
